import { render, staticRenderFns } from "./AxFold.vue?vue&type=template&id=abca86d0&scoped=true&"
import script from "./AxFold.vue?vue&type=script&lang=js&"
export * from "./AxFold.vue?vue&type=script&lang=js&"
import style0 from "./AxFold.vue?vue&type=style&index=0&id=abca86d0&lang=scss&scoped=true&"
import style1 from "./AxFold.vue?vue&type=style&index=1&id=abca86d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abca86d0",
  null
  
)

export default component.exports